/**
 * <GuestSearchDrawer> — universal search launched via F2 or search button.
 */
import { useEffect, useState, useCallback } from "react";
import { OperationalDrawer, GuestSearchPanel } from "@/components/operational";
import { foApi , formatApiError } from "../foApi";

const LS_RECENT = "fo.recent_searches";

export default function GuestSearchDrawer({ open, onOpenChange, onPickGuest, hotelId }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    if (open) {
      setQ("");
      setResults([]);
      try { setRecent(JSON.parse(localStorage.getItem(LS_RECENT) || "[]")); } catch { setRecent([]); }
    }
  }, [open]);

  useEffect(() => {
    if (!q || q.length < 2) { setResults([]); return; }
    const t = setTimeout(async () => {
      setLoading(true);
      try {
        const r = await foApi.search(q, { hotel_id: hotelId });
        setResults(r.results || []);
      } finally { setLoading(false); }
    }, 250);
    return () => clearTimeout(t);
  }, [q, hotelId]);

  const pick = useCallback((row) => {
    // Persist recent
    try {
      const next = [q, ...recent.filter(x => x !== q)].filter(Boolean).slice(0, 8);
      localStorage.setItem(LS_RECENT, JSON.stringify(next));
    } catch { /* ignore */ }
    // Resolve to guest_id (guest, reservation, stay, folio all carry guest_id)
    const gid = row.guest_id || (row.type === "guest" ? row.id : null);
    if (gid) onPickGuest?.(gid, row);
  }, [q, recent, onPickGuest]);

  return (
    <OperationalDrawer open={open} onOpenChange={onOpenChange}
      title="Universal Guest Search" subtitle="Name · Phone · Room · Reservation · Folio · Passport…"
      size="md" testid="guest-search-drawer">
      <div className="p-4">
        <GuestSearchPanel
          query={q}
          onQueryChange={setQ}
          onClear={() => { setQ(""); setResults([]); }}
          onSelect={pick}
          loading={loading}
          results={results}
          recentSearches={recent}
          recentGuests={[]}
          autoFocus
          testid="fo-search"
        />
      </div>
    </OperationalDrawer>
  );
}
